import React, { useState, useEffect } from 'react';
import api from '../services/api';

function BookList() {
  const [books, setBooks] = useState([]);
  const [newBook, setNewBook] = useState({ title: '', author: '' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBooks();
  }, []);

  const fetchBooks = async () => {
    try {
      const response = await api.get('/books');
      setBooks(response.data);
    } catch (error) {
      console.error('Error fetching books:', error);
    } finally {
      setLoading(false);
    }
  };

  const addBook = async (e) => {
    e.preventDefault();
    try {
      await api.post('/books', newBook);
      setNewBook({ title: '', author: '' });
      fetchBooks();
    } catch (error) {
      console.error('Error adding book:', error);
    }
  };

  const deleteBook = async (id) => {
    try {
      await api.delete(`/books/${id}`);
      fetchBooks();
    } catch (error) {
      console.error('Error deleting book:', error);
    }
  };

  if (loading) return <div>Loading books...</div>;

  return (
    <div>
      <h2>Books Management</h2>
      
      <form onSubmit={addBook} style={{marginBottom: '20px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '4px'}}>
        <h3>Add New Book</h3>
        <div style={{display: 'flex', gap: '10px', marginBottom: '10px'}}>
          <input
            type="text"
            placeholder="Title"
            value={newBook.title}
            onChange={(e) => setNewBook({...newBook, title: e.target.value})}
            style={{flex: 1, padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
            required
          />
          <input
            type="text"
            placeholder="Author"
            value={newBook.author}
            onChange={(e) => setNewBook({...newBook, author: e.target.value})}
            style={{flex: 1, padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
            required
          />
        </div>
        <button type="submit" style={{
          padding: '8px 16px',
          backgroundColor: '#28a745',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}>
          Add Book
        </button>
      </form>

      <div>
        <h3>Book List ({books.length} books)</h3>
        {books.length === 0 ? (
          <p>No books available.</p>
        ) : (
          <table style={{width: '100%', borderCollapse: 'collapse'}}>
            <thead>
              <tr style={{backgroundColor: '#f8f9fa'}}>
                <th style={{padding: '10px', border: '1px solid #ddd', textAlign: 'left'}}>Title</th>
                <th style={{padding: '10px', border: '1px solid #ddd', textAlign: 'left'}}>Author</th>
                <th style={{padding: '10px', border: '1px solid #ddd', textAlign: 'left'}}>Status</th>
                <th style={{padding: '10px', border: '1px solid #ddd', textAlign: 'left'}}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {books.map((book) => (
                <tr key={book.id}>
                  <td style={{padding: '10px', border: '1px solid #ddd'}}>{book.title}</td>
                  <td style={{padding: '10px', border: '1px solid #ddd'}}>{book.author}</td>
                  <td style={{padding: '10px', border: '1px solid #ddd'}}>
                    <span style={{
                      padding: '4px 8px',
                      borderRadius: '4px',
                      backgroundColor: book.is_checked_out ? '#dc3545' : '#28a745',
                      color: 'white',
                      fontSize: '12px'
                    }}>
                      {book.is_checked_out ? 'Checked Out' : 'Available'}
                    </span>
                  </td>
                  <td style={{padding: '10px', border: '1px solid #ddd'}}>
                    <button
                      onClick={() => deleteBook(book.id)}
                      style={{
                        padding: '4px 8px',
                        backgroundColor: '#dc3545',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '12px'
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default BookList;
